// Use the review section's scroll margin so the sticky header cannot cover it.
document.addEventListener('click', (event) => {
  const link = event.target.closest('[data-product-review-link]');
  if (!link || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
  const reviews = document.getElementById('stamped-main-widget');
  if (!reviews) return;
  event.preventDefault();
  event.stopImmediatePropagation();
  reviews.tabIndex = -1;
  reviews.focus({ preventScroll: true });
  const offset = parseFloat(getComputedStyle(reviews).scrollMarginTop) || 112;
  requestAnimationFrame(() => {
    window.scrollTo({ top: window.scrollY + reviews.getBoundingClientRect().top - offset, behavior: 'instant' });
  });
}, true);
